'use client';

import React from 'react';
import Image from 'next/image';
import { CgChevronDoubleDown } from 'react-icons/cg';


const HeroBanner: React.FC<{slogan:string}> = ({ slogan }) => {
    const handleScroll = () => {
        window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
    };
    return (
        <div className="relative w-full md:h-[calc(100vh-160px)] h-[50vh] overflow-hidden">
            <div className="absolute inset-0">
                <Image
                    src="/images/hero.jpg"
                    alt="Fallback background"
                    fill
                    className="object-cover"
                    priority
                />
            </div>

            <video
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
                poster="/images/hero.jpg"
            >
                <source src="/video/hero.mp4" type="video/mp4" />
            </video>

            <div className="absolute inset-0 bg-[url('/video/texture.svg')] opacity-20 mix-blend-overlay pointer-events-none" />

            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-transparent z-10" />

            <div className="relative z-20 flex flex-col items-center justify-center text-center text-white h-full px-4">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 uppercase">
                    Нарс хүүхдийн зуслан
                </h1>
                <p className="text-lg md:text-2xl max-w-xl drop-shadow-md font-semibold">
                    <span dangerouslySetInnerHTML={{ __html: slogan }} />
                </p>
            </div>
            

            <button
                onClick={handleScroll}
                className="absolute bottom-20 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce md:block hidden"
                aria-label="Scroll down"
            >
                <CgChevronDoubleDown className="md:w-12 md:h-12 w-8 h-8" />
            </button>


            {/* <div className="absolute bottom-0 left-0 right-0 z-10 overflow-hidden leading-[0]">
    <svg
        className="w-full h-[100px] block"
        viewBox="0 0 1440 320"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
    >
        <path
            fill="#2eaf30"
            d="M0,96L48,122.7C96,149,192,203,288,218.7C384,235,480,213,576,181.3C672,149,768,107,864,106.7C960,107,1056,149,1152,170.7C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
    </svg>
</div> */}
            
        </div>
    );
};

export default HeroBanner;
